import React, { useEffect } from 'react'
import AOS from "aos";
import "aos/dist/aos.css";

function About() {

  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);
  return (
    <div>
      <section className="home-about bg-light-grey" style={{ overflowX: "hidden" }}>
        <div className="container">
          <div className="about-head-wrap">
            <div className="section-head-outer">
              <div className="section-head" data-aos="fade-up">
                <div className="title-divider" />
                <h2 className="section-title">
                  Introduction About Corporate{" "}
                  <span className="primary-color">Business</span>
                </h2>
              </div>
            </div>

            <div className="about-dec" data-aos="fade-right">
              <p>
                At Codenix Infotech, we drive growth through AI automation, innovation, and technology, partnering with businesses across
                industries to deliver intelligent automation solutions, AI-driven consulting, and digital transformation strategies.
                With expertise in custom IT solutions and enterprise-grade software development, we empower organizations to scale, optimize operations, and stay ahead in today’s competitive, ever-evolving market
              </p>
            </div>

            <div className="exp-date-wrap" data-aos="fade-right">
              <div className="exp-date">
                <h2>100+</h2>
                <h4>PROJECTS COMPLETED</h4>
              </div>
            </div>
          </div>

          <div className="about-inner">
            <div className="row g-0">
              {/* Left Side - Video Section */}
              <div className="col-md-6">
                <div
                  className="about-video-banner d-flex align-items-center justify-content-center"
                  style={{ backgroundImage: "url(/assets/images/img14.jpg)" }}
                >
                  {/* <div className="video-button">
              <a id="video-container" data-video-id="IUN664s7N-c">
                <i aria-hidden="true" className="icon icon-play1" />
              </a>
            </div> */}
                </div>
              </div>

              {/* Right Side - Content + Progress */}
              <div className="col-md-6" >
                <div className="progress-content">
                  <p>
                    <em className="primary-color">
                      “Empowering businesses with technology that transforms challenges
                      into opportunities, and ideas into impactful solutions.”
                    </em>
                  </p>

                  <div className="progress-wrapper">
                    <div
                      className="ab-progress example"
                      data-title="CORPORATE MANAGEMENT"
                      data-progress=""
                      data-value={90}
                    />
                    <div
                      className="ab-progress example"
                      data-title="BUSINESS INTEGRATION"
                      data-progress=""
                      data-value={85}
                    />
                    <div
                      className="ab-progress example"
                      data-title="PLANS IMPLEMENTATION"
                      data-progress=""
                      data-value={95}
                    />
                  </div>

                  <a href="/about" className="button-round">
                    LEARN MORE
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>


    </div>
  )
}

export default About
